import {} from "./Net.js";
import { findHalfEdgeEntry } from "./findHalfEdgeEntry.js";
export function disconnectPortEntry(net, portEntry) {
    var _a;
    const halfEdge = (_a = portEntry.connection) === null || _a === void 0 ? void 0 : _a.halfEdge;
    delete portEntry.connection;
    if (halfEdge !== undefined) {
        const halfEdgeEntry = findHalfEdgeEntry(net, halfEdge);
        if (halfEdgeEntry === undefined) {
            throw new Error(`[disconnectPort] Fail to find halfEdgeEntry`);
        }
        delete halfEdgeEntry.port;
    }
}
//# sourceMappingURL=disconnectPortEntry.js.map